import t from "./ghl-ui.es728.js";
import i from "./ghl-ui.es729.js";
function e(r) {
  return r != null && i(r.length) && !t(r);
}
export {
  e as default
};
